import gql from 'graphql-tag';

export const GET_CUSTOMIZATION = gql`
  query GetCustomization {
    getCustomization {
      onboarding {
        fields {
          key
          subfields {
            key
            condition {
              operator
              value
            }
            active
          }
          active
        }
      }
    }
  }
`;

export type GetCustomizationResponse = {
  getCustomization: Omit<IWhitelabelCustomization, 'organizationId'>;
};
